import { jaErrorMap } from '@data/zod';
import { extendZodWithMobxZodForm } from '@monoid-dev/mobx-zod-form';
import { z } from 'zod';

extendZodWithMobxZodForm(z);
z.setErrorMap(jaErrorMap);

// Node polyfills
globalThis.File = globalThis.File ?? class File {};
globalThis.Blob = globalThis.Blob ?? class Blob {};
